module.exports = __webpack_public_path__ + "static/media/icomoon.84676dbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon/icomoon.svg?24fgiz
// module id = 2941
// module chunks = 0